import { ThemeEvents } from '@theme/events';

/**
 * Swaps the visible specifications panel to match the selected variant.
 *
 * Each variant's spec sheet is rendered server-side as a hidden
 * `.aeon-specs-variant` block. This component listens for variant updates
 * (which bubble to the document) and reveals the block whose
 * `data-variant-id` matches the newly selected variant.
 */
class ProductSpecsComponent extends HTMLElement {
  connectedCallback() {
    this.updateSpecs = this.updateSpecs.bind(this);
    document.addEventListener(ThemeEvents.variantUpdate, this.updateSpecs);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this.updateSpecs);
  }

  updateSpecs(event) {
    const { resource, data } = event.detail ?? {};
    const productId = data?.productId;

    // Ignore updates for a different product (e.g. a product card on the page).
    if (productId && this.dataset.productId && String(productId) !== this.dataset.productId) return;
    if (!resource) return;

    const variantId = String(resource.id);
    const variantPanels = this.querySelectorAll('.aeon-specs-variant');
    const defaultPanel = this.querySelector('.aeon-specs-default');
    let matched = false;

    variantPanels.forEach((panel) => {
      const isMatch = panel.dataset.variantId === variantId;
      panel.hidden = !isMatch;
      if (isMatch) matched = true;
    });

    // Show the static fallback panel when no variant-specific panel matches.
    if (defaultPanel) {
      defaultPanel.hidden = matched;
    }

    this.dataset.selectedVariantId = variantId;
  }
}

if (!customElements.get('product-specs-component')) {
  customElements.define('product-specs-component', ProductSpecsComponent);
}
